
export * from '../../frontend-js-dependencies-web/__liferay__/exports/cropperjs.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/cropperjs.js';
export default __default__;
